import { render, staticRenderFns } from "./PlatinMarket.vue?vue&type=template&id=b18004fc&scoped=true"
import script from "./PlatinMarket.vue?vue&type=script&lang=js"
export * from "./PlatinMarket.vue?vue&type=script&lang=js"
import style0 from "./PlatinMarket.vue?vue&type=style&index=0&id=b18004fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b18004fc",
  null
  
)

export default component.exports